<template>
  <div class="do">
    <van-swipe :autoplay="3000" indicator-color="#fad4e3">
      <van-swipe-item v-for="doUrl in doUrls" :key="doUrl.id">
        <div class="do-img">
           <van-image
            :src="doUrl"
          >
            <template v-slot:loading>
              <van-loading size="20" color="#fff" />
            </template>
          </van-image>
        </div>
      </van-swipe-item>
    
    </van-swipe>
  </div>
</template>

<script>
export default {
  data() {
    return {
      doUrls:this.doUrl
    };
  },
  props: {
   doUrl:{
     type:Array,
     default:[]
   }
  }
};
</script>

<style scoped>
.fit-img {
  width: 100%;
  height: 100%;
}

.do-img {
  width: 100%;
}
</style>

